import { SignupMediaPanelFullPage } from './SignupMediaPanelFullPage';
import { SignupMediaPanelNormal } from './SignupMediaPanelNormal';

export type MediaAsset = {
  Image?: string | Record<string, unknown> | null;
};

export type SignupMediaPanelProps = {
  mediaContent: {
    Content?: string;
    MobileMedia?: MediaAsset;
    Media?: MediaAsset;
  };
  isFullPageMode: boolean;
  activeIndex: number;
};

export function SignupMediaPanel({
  mediaContent,
  isFullPageMode,
  activeIndex,
}: SignupMediaPanelProps) {
  if (isFullPageMode) {
    return (
      <SignupMediaPanelFullPage
        mediaContent={mediaContent}
        activeIndex={activeIndex}
        isFullPageMode={isFullPageMode}
      />
    );
  }

  return (
    <SignupMediaPanelNormal
      mediaContent={mediaContent}
      activeIndex={activeIndex}
      isFullPageMode={isFullPageMode}
    />
  );
}
